<template>
  <hr aria-hidden="true" />
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";

hr {
  background-color: colors.$alpha-10;
  width: calc(100% + 8px);
  height: 1px;
  margin-inline: -4px;
}
</style>
